/**
 * Block loader
 * 
 * Welcome to camelCase Anonymous.
 * 
 * Allows you to better separate JS files and only loads the script where its associated 
 * block is in use. Passes through the jQuery element to that JS script allowing the script
 * to run its magic on that object only.
 * 
 * Bases the block it is searching for on the page the script is under, and the script name
 * For example, the script loremIpsumDolor until partials.home will execute on any block
 * with the class home-lorem-ipsum-dolor
 * 
 * For consistency, this example block would be arranged as such:
 * => Blade: views/partials/home/lorem-ipsum-dolor.blade.php
 * => SCSS:  assets/styles/layouts/partials/home/_lorem-ipsum-dolor.scss
 * => JS:    assets/scripts/partials/home/loremIpsumDolor.js
 */

// Other partials which should always run
import navigation from './other/navigation';
import navigationMobile from './other/navigationMobile';
import alert from './other/alert';
import banner from './other/banner';
import browsealoud from './other/browsealoud';

// Shared partials
import threeColumnCta from './shared/threeColumnCta';

// Home partials
import latestNews from './home/latestNews';
import latestEvents from './home/latestEvents';

// Flexible partials
import frequentlyAskedQuestions from './flexible/frequentlyAskedQuestions';
import iconAndTextLinks from './flexible/iconAndTextLinks';
import fullWidthVideo from './flexible/fullWidthVideo';
import fullWidthGallery from './flexible/fullWidthGallery';

var partials = {
  shared: { threeColumnCta },
  home: { latestNews, latestEvents },
  flexible: { frequentlyAskedQuestions, iconAndTextLinks, fullWidthVideo, fullWidthGallery },
  other: { navigation, navigationMobile, alert, banner, browsealoud },
};

export default {
  getPartialElement(script) {
    return String(script).replace(/([A-Z])/g, '-$1').toLowerCase();
  },
  getPageElement(page) {
    return page.replace(/([A-Z])/g, '-$1').toLowerCase();
  },
  init() {
    // Execute init function on all partials on the current page
    for (const page in partials) {
      for (const script in partials[page]) {
        const pageFriendly = this.getPageElement(page);
        if (page == 'other') {
          partials[page][script].init();
        } else {
          const element = this.getPartialElement(script);
          if ($(`.${pageFriendly}-${element}`).length > 0) {
            $(`.${pageFriendly}-${element}`).each(function() {
              partials[page][script].init($(this));
            });
          }
        }
      }
    }
  },
  finalize() {
    // Execute finalize function on all partials on the current page
    for (const page in partials) {
      for (const script in partials[page]) {
        const pageFriendly = this.getPageElement(page);
        if (page == 'other') {
          partials[page][script].finalize();
        } else {
          const element = this.getPartialElement(script);
          if ($(`.${pageFriendly}-${element}`).length > 0) {
            $(`.${pageFriendly}-${element}`).each(function() {
              partials[page][script].finalize($(this));
            });
          }
        }
      }
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/loader.js